import { CurrencyCodeEnum } from "@vini-wine/core-enums";
import { PriceDto } from "@vini-wine/core-dtos";

export interface PriceModel {
  // transform
  priceMicros: number;
  currency: CurrencyCodeEnum;
}

export const createPriceDtoFromAdminPriceModel = (
  price: PriceModel,
): PriceDto => {
  return {
    priceMicros: price.priceMicros,
    currency: price.currency,
  };
};
